import { useCallback, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import { IDimensionalityOption } from 'constants/businessTool';
import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { GLOBAL_UNIT_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { unitConvertorMultiplier } from '../../helpers/balanceSheet/consts';
import { useUpdateFinancialPlanTables } from '../../helpers/balanceSheet/useUpdateFinancialPlanTables';
import { useUpdateOpenBalanceSheet } from '../../helpers/balanceSheet/useUpdateOpenBalanceSheet';
import { IFormContentTypes } from '../../utils/form';

export const useRecalculateOnUnitChange = () => {
  const { getValues } = useFormContext();
  const previousValue = useRef<IDimensionalityOption>(getValues(GLOBAL_UNIT_NAME));

  const openBalanceSheetUpdateHandler = useUpdateOpenBalanceSheet();
  const financialPlanTablesUpdateHandler = useUpdateFinancialPlanTables();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const useRecalculateOnUnitChangeHandler = useCallback((content: IFormContentTypes['currentUnit']) => {
    if (!canAccess) return;
    const unit = content[0];

    const multiplier = unitConvertorMultiplier[previousValue.current][unit];
    previousValue.current = unit;
    openBalanceSheetUpdateHandler(multiplier);
    financialPlanTablesUpdateHandler(multiplier);
  }, []);

  return useRecalculateOnUnitChangeHandler;
};
